// @ts-check
export const stringifyCopyBag = value => {
  return `${value.length}`;
};